import Section from 'components/common/Section/Section';
import CustomCarousel from 'components/common/CustomCarousel/CustomCarousel';
import { Box } from '@mui/material';
import { useCategoryContext } from 'context/CategoryContext';
import { getTranslations } from 'common/utils';
import { useNavigate } from 'react-router-dom';
import AddIcon from 'icons/AddIcon';
import { colors } from 'styles/colors';
import { ReactNode } from 'react';

type Props = {
  basePath?: string;
  // What the section shows for this category - products by default, but the
  // raw products page hands in its own row.
  carousel?: ReactNode;
  showAdd?: boolean;
  subtitle?: string;
};

export default function CategorySection({
  basePath = '/categories/all-categories',
  carousel,
  showAdd = true,
  subtitle,
}: Props) {
  const navigate = useNavigate();
  const { category } = useCategoryContext();

  const { ar, en } = getTranslations(category.translations);

  return (
    <Section
      title={en.name}
      titleHint={ar.name}
      subtitle={subtitle}
      carousel={carousel ?? <CustomCarousel />}
      contentPadding={0}
      // The page drilled into only loads the children, so it is handed the
      // name it is showing.
      onTitlePress={() => navigate(`${basePath}/${category.id}`, { state: { categoryName: en.name } })}
      // A category's heading drills into it, so it is never a fold as well.
      collapsed={false}
      buttons={showAdd && category.isLeafCategory ? [
        {
          icon: <AddIcon size={20} color={colors.primary} />,
          title: 'Add',
          onClick: () => console.log('add', category),
          // disabled: isLoading,
        },
      ] : []}
    />
  )
}
